export default __webpack_public_path__ + "static/star@2x-76c25e300d601ac7ba41347fb1ea9f40.png";